"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DateFormatter;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function DateFormatter(_ref) {
  var _column$options, _column$options2;

  var row = _ref.row,
      column = _ref.column;
  var value = row[column.key];
  var includeTime = (_column$options = column.options) === null || _column$options === void 0 ? void 0 : _column$options.includeTimeField;
  var timeFormat = (_column$options2 = column.options) === null || _column$options2 === void 0 ? void 0 : _column$options2.timeFormat;
  var format = includeTime ? timeFormat === 12 ? "MM/DD/YYYY hh:mm a" : "MM/DD/YYYY HH:mm" : "MM/DD/YYYY";
  return value ? (0, _moment["default"])(value).format(format) : null;
}